import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
export default function Logo() {
  return <Link href="/" className="flex gap-2 items-center" data-sentry-element="Link" data-sentry-component="Logo" data-sentry-source-file="logo.tsx">
      <span className="sr-only">Zaars</span>
      <Image src={'/images/logo-text.webp'} alt="Zaars logo" className="h-9 w-auto" width={1920} height={1080} priority data-sentry-element="Image" data-sentry-source-file="logo.tsx" />
    </Link>;
}